module.exports = __webpack_public_path__ + "img/closeIcon.c3ff59a1.svg";